import React from "react";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer
      className="mt-12 pt-12 pb-8 px-6 md:px-12"
      style={{
        borderTop: "1px solid var(--border-subtle)",
        background: "var(--bg-surface)",
      }}
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <img src="/logo.png" alt="PK2 Scarlett" style={{ maxHeight: "90px", width: "auto" }} className="mb-4" />
          <p className="text-sm leading-relaxed max-w-md" style={{ color: "var(--text-secondary)" }}>
            {t("footer.description")}
          </p>
        </div>

        <div>
          <div className="overline mb-4">{t("footer.explore")}</div>
          <ul className="space-y-3 text-sm" style={{ color: "var(--text-secondary)" }}>
            <li><a href="/galeria" className="hover:text-white transition-colors">{t("footer.gallery")}</a></li>
            <li><a href="/vip" className="hover:text-white transition-colors">{t("footer.vip_musas")}</a></li>
            <li><a href="/registro" className="hover:text-white transition-colors">{t("footer.publish_profile")}</a></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">{t("footer.legal")}</div>
          <ul className="space-y-3 text-sm" style={{ color: "var(--text-secondary)" }}>
            <li><a href="/terminos" className="hover:text-white transition-colors" data-testid="footer-terms">{t("footer.terms")}</a></li>
            <li><a href="/privacidad" className="hover:text-white transition-colors" data-testid="footer-privacy">{t("footer.privacy_notice")}</a></li>
            <li>{t("footer.adults_only")}</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4" style={{ borderTop: "1px solid var(--border-subtle)" }}>
        <p className="text-xs" style={{ color: "var(--text-muted)" }}>
          {t("footer.copyright", { year: new Date().getFullYear() })}
        </p>
        <p className="text-xs" style={{ color: "var(--text-muted)" }}>
          {t("footer.adults_only_footer")}
        </p>
      </div>
    </footer>
  );
}
